import {
  PaymentPreviewErrorPayload,
  PaymentPreviewHostedPaymentV1Response,
} from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, props } from '@ngrx/store';

export const HostedPaymentsSelectPaymentMethodPaymentInfoActions =
  createActionGroup({
    source: 'Hosted Payments Select Payment Method Payment Info',
    events: {
      'Update Payment Preview Success': props<{
        response: PaymentPreviewHostedPaymentV1Response;
        redirectToTwikey: boolean;
      }>(),
      'Update Payment Preview Error': props<{
        error: PaymentPreviewErrorPayload;
      }>(),
    },
  });
